import { render } from "./PosCustomerDisplayPage.vue?vue&type=template&id=43683768&scoped=true&ts=true"
import script from "./PosCustomerDisplayPage.vue?vue&type=script&lang=ts"
export * from "./PosCustomerDisplayPage.vue?vue&type=script&lang=ts"

import "./PosCustomerDisplayPage.vue?vue&type=style&index=0&id=43683768&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43683768"]])

export default __exports__